(function () {
  // Helper: smooth scroll
  function smoothScrollTo(el) {
    if (!el) return;
    el.scrollIntoView({ behavior: "smooth" });
  }

  var root = document.getElementById("bass-boots-drop-002");
  if (!root) return;

  // ===================== COUNTDOWN TO MIDNIGHT =====================
  (function initCountdown() {
    var hEl = document.getElementById("bb-countdown-hours");
    var mEl = document.getElementById("bb-countdown-mins");
    var sEl = document.getElementById("bb-countdown-secs");
    if (!hEl || !mEl || !sEl) return;

    function updateCountdown() {
      var now = new Date();
      var end = new Date();
      end.setHours(24, 0, 0, 0); // midnight tonight

      var diff = end - now;
      var totalSeconds = Math.max(0, Math.floor(diff / 1000));
      var hours = Math.floor(totalSeconds / 3600);
      var mins = Math.floor((totalSeconds % 3600) / 60);
      var secs = totalSeconds % 60;

      hEl.textContent = String(hours).padStart(2, "0");
      mEl.textContent = String(mins).padStart(2, "0");
      sEl.textContent = String(secs).padStart(2, "0");
    }

    updateCountdown();
    setInterval(updateCountdown, 1000);
  })();

  // ===================== VIEWER COUNT JITTER =====================
  (function initViewers() {
    var viewersEl = document.getElementById("bb-viewers-count");
    if (!viewersEl) return;
    var viewers = parseInt(viewersEl.textContent || "180", 10) || 180;

    function updateViewers() {
      var delta = Math.floor(Math.random() * 5) - 2; // -2..+2
      viewers = Math.min(220, Math.max(160, viewers + delta));
      viewersEl.textContent = String(viewers);
    }

    setInterval(updateViewers, 8000);
  })();

  // ===================== CART BADGE / AJAX CART =====================
  var cartButton = document.getElementById("bb-cart-button");
  var cartBadge;

  function ensureCartBadge() {
    if (cartBadge) return cartBadge;
    if (!cartButton) return null;

    var iconWrapper = cartButton.querySelector(".bb-cart-icon-wrapper");
    if (!iconWrapper) {
      iconWrapper = document.createElement("span");
      iconWrapper.className = "bb-cart-icon-wrapper";
      var icon = cartButton.querySelector(".bb-cart-icon");
      if (icon) {
        icon.parentNode.insertBefore(iconWrapper, icon);
        iconWrapper.appendChild(icon);
      } else {
        cartButton.appendChild(iconWrapper);
      }
    }

    cartBadge = document.createElement("span");
    cartBadge.id = "bb-cart-count-badge";
    cartBadge.className = "bb-cart-count-badge";
    cartBadge.style.display = "none";
    cartBadge.textContent = "0";
    iconWrapper.appendChild(cartBadge);
    return cartBadge;
  }

  function updateCartBadge(count) {
    var badge = ensureCartBadge();
    if (!badge) return;
    if (count > 0) {
      badge.textContent = String(count);
      badge.style.display = "inline-flex";
    } else {
      badge.textContent = "0";
      badge.style.display = "none";
    }
  }

  function fetchCartCount() {
    fetch("/cart.js", { credentials: "same-origin" })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        updateCartBadge(data.item_count || 0);
      })
      .catch(function () {});
  }

  fetchCartCount();

  if (cartButton) {
    cartButton.addEventListener("click", function () {
      window.location.href = "/cart";
    });
  }

  function addLineItemAjax(variantId, quantity, properties, onSuccess) {
    if (!variantId) return;

    var payload = {
      id: variantId,
      quantity: quantity || 1,
    };
    if (properties && Object.keys(properties).length) {
      payload.properties = properties;
    }

    fetch("/cart/add.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify(payload),
    })
      .then(function (res) {
        return res.json();
      })
      .then(function (data) {
        fetchCartCount();
        if (typeof onSuccess === "function") onSuccess(data);
      })
      .catch(function () {});
  }

  // ===================== BUNDLE LOGIC (1/2/3 PAIRS) =====================
  var bundleCards = root.querySelectorAll(".bb-bundle-card");
  var mainCta = document.getElementById("bb-main-cta");

  var selectedBundle = 1; // 1, 2, or 3
  var selectedSizes = {
    1: "",
    2: "",
    3: "",
  };
  var selectedStyle = "Chrome Edition"; // Only Chrome is active

  function getBundleSizeFromCard(card) {
    if (!card) return 1;
    var b = parseInt(card.getAttribute("data-bundle") || "1", 10);
    return b >= 1 && b <= 3 ? b : 1;
  }

  function getActiveBundleCard() {
    return root.querySelector(".bb-bundle-card.bb-bundle-active");
  }

  // Helper: visually mark Chrome as selected inside a given card
  function setChromeSelectedForCard(card) {
    if (!card) return;
    var chromeOpt = card.querySelector('.bb-style-option[data-style="chrome"]');
    if (!chromeOpt) return;

    // remove selected classes from all style options & dots in this card
    card.querySelectorAll(".bb-style-option").forEach(function (opt) {
      opt.classList.remove("bb-style-selected");
    });
    card.querySelectorAll(".bb-style-dot").forEach(function (dot) {
      dot.classList.remove("bb-style-dot-active");
    });

    // add selected classes to chrome pill + its dot
    chromeOpt.classList.add("bb-style-selected");
    var chromeDot = chromeOpt.querySelector(".bb-style-dot");
    if (chromeDot) chromeDot.classList.add("bb-style-dot-active");
  }

  // Build the Chrome/White row + size dropdowns inside each card at runtime
  function buildBundleDetails() {
    bundleCards.forEach(function (card) {
      var bundleSize = getBundleSizeFromCard(card);
      // Avoid double-inserting if this script runs twice somehow
      if (card.querySelector(".bb-bundle-details")) return;

      var details = document.createElement("div");
      details.className = "bb-bundle-details";

      // Style row
      var styleRow = document.createElement("div");
      styleRow.className = "bb-style-row";

      var chromeOption = document.createElement("div");
      chromeOption.className = "bb-style-option";
      chromeOption.setAttribute("data-style", "chrome");
      chromeOption.setAttribute("role", "button");
      chromeOption.setAttribute("aria-pressed", "true");
      chromeOption.innerHTML =
        '<span class="bb-style-dot bb-style-dot-chrome"></span>' +
        '<span class="bb-style-label">Chrome <strong>(Selected)</strong></span>';

      var whiteOption = document.createElement("div");
      whiteOption.className = "bb-style-option bb-style-disabled";
      whiteOption.setAttribute("data-style", "white");
      whiteOption.setAttribute("aria-disabled", "true");
      whiteOption.innerHTML =
        '<span class="bb-style-dot bb-style-dot-white"></span>' +
        '<span class="bb-style-label">White – Sold out</span>';

      styleRow.appendChild(chromeOption);
      styleRow.appendChild(whiteOption);
      details.appendChild(styleRow);

      // Size selects for each pair
      for (var i = 1; i <= bundleSize; i++) {
        var row = document.createElement("div");
        row.className = "bb-sizes-row";

        var label = document.createElement("label");
        label.className = "bb-size-label";
        label.textContent = "Pair " + i + " size";

        var select = document.createElement("select");
        select.className = "bb-size-select";
        select.setAttribute("data-bundle", String(bundleSize));
        select.setAttribute("data-pair-index", String(i));

        var options = [
          "",
          "Men’s 5 (Women’s 6.5–7)",
          "Men’s 6 (Women’s 7.5–8)",
          "Men’s 7 (Women’s 8.5–9)",
          "Men’s 8 (Women’s 9.5–10)",
          "Men’s 9 (Women’s 10.5–11)",
          "Men’s 10 (Women’s 11.5–12)",
          "Men’s 11 (Women’s 12.5–13)",
          "Men’s 12 (Women’s 13.5–14)",
        ];

        options.forEach(function (val, idx) {
          var opt = document.createElement("option");
          opt.value = val;
          opt.textContent = idx === 0 ? "Select size" : val;
          if (idx === 0) opt.selected = true;
          select.appendChild(opt);
        });

        row.appendChild(label);
        row.appendChild(select);
        details.appendChild(row);
      }

      card.appendChild(details);
      // visually mark Chrome as selected for this card
      setChromeSelectedForCard(card);
    });
  }

  buildBundleDetails();

  function resetBundleSizes() {
    selectedSizes[1] = "";
    selectedSizes[2] = "";
    selectedSizes[3] = "";

    var active = getActiveBundleCard();
    if (!active) return;

    var selects = active.querySelectorAll(".bb-size-select");
    selects.forEach(function (sel) {
      sel.value = "";
    });
  }

  function allRequiredSizesChosen() {
    for (var i = 1; i <= selectedBundle; i++) {
      if (!selectedSizes[i]) return false;
    }
    return true;
  }

  function updateMainCtaState() {
    if (!mainCta) return;
    var validStyle = selectedStyle === "Chrome Edition";
    var validSizes = allRequiredSizesChosen();
    if (validStyle && validSizes) {
      mainCta.disabled = false;
      mainCta.classList.remove("bb-main-cta-disabled");
    } else {
      mainCta.disabled = true;
      mainCta.classList.add("bb-main-cta-disabled");
    }
  }

  // Card click (radio behavior)
  bundleCards.forEach(function (card) {
    card.addEventListener("click", function (e) {
      // Ignore clicks on selects or style options
      if (e.target.closest(".bb-size-select") || e.target.closest(".bb-style-option")) {
        return;
      }

      bundleCards.forEach(function (c) {
        c.classList.remove("bb-bundle-active");
      });
      card.classList.add("bb-bundle-active");

      selectedBundle = getBundleSizeFromCard(card);
      resetBundleSizes();
      selectedStyle = "Chrome Edition"; // Chrome always selected
      setChromeSelectedForCard(card);

      updateMainCtaState();
    });

    // Style row inside each card (Chrome only)
    var chromeOpt = card.querySelector('.bb-style-option[data-style="chrome"]');
    if (chromeOpt) {
      chromeOpt.addEventListener("click", function (e) {
        e.stopPropagation();
        selectedStyle = "Chrome Edition";
        setChromeSelectedForCard(card);
        updateMainCtaState();
      });
    }

    var whiteOpt = card.querySelector('.bb-style-option[data-style="white"]');
    if (whiteOpt) {
      whiteOpt.addEventListener("click", function (e) {
        e.stopPropagation();
        // White sold out, do nothing
      });
    }

    // Size selects inside each card
    var selects = card.querySelectorAll(".bb-size-select");
    selects.forEach(function (sel) {
      sel.addEventListener("click", function (e) {
        e.stopPropagation();
      });
      sel.addEventListener("change", function () {
        var pairIndex = parseInt(sel.getAttribute("data-pair-index") || "1", 10) || 1;
        selectedSizes[pairIndex] = sel.value || "";
        updateMainCtaState();
      });
    });
  });

  // Initialize default: first card active, Chrome style, no sizes chosen
  var firstCard = root.querySelector('.bb-bundle-card[data-bundle="1"]');
  if (firstCard) {
    firstCard.classList.add("bb-bundle-active");
    selectedBundle = 1;
    setChromeSelectedForCard(firstCard);
  }
  updateMainCtaState();

  // ===================== MAIN CTA → ADD FOUNDER DEPOSIT + REDIRECT =====================
  if (mainCta) {
    mainCta.addEventListener("click", function () {
      if (mainCta.disabled) return;

      var founderVariantId = parseInt(
        mainCta.getAttribute("data-founder-variant-id") || "0",
        10
      );
      if (!founderVariantId) {
        console.warn("Missing founder-deposit variant ID on main CTA.");
        return;
      }

      if (!allRequiredSizesChosen()) {
        updateMainCtaState();
        return;
      }

      var properties = {
        Style: "Chrome Edition",
      };
      if (selectedSizes[1]) properties["Pair 1 Size"] = selectedSizes[1];
      if (selectedBundle >= 2 && selectedSizes[2]) {
        properties["Pair 2 Size"] = selectedSizes[2];
      }
      if (selectedBundle >= 3 && selectedSizes[3]) {
        properties["Pair 3 Size"] = selectedSizes[3];
      }

      // quantity = selectedBundle (1, 2, or 3)
      addLineItemAjax(
        founderVariantId,
        selectedBundle,
        properties,
        function () {
          window.location.href = "/checkout";
        }
      );
    });
  }

  // ===================== ADD-ON PRODUCTS (AJAX) =====================
  var addonButtons = root.querySelectorAll(".bb-addon-btn");
  addonButtons.forEach(function (btn) {
    btn.addEventListener("click", function () {
      var vid = parseInt(btn.getAttribute("data-variant-id") || "0", 10);
      if (!vid) {
        console.warn("Missing data-variant-id on add-on button.");
        return;
      }
      addLineItemAjax(vid, 1, {}, function () {
        // stay on page, badge updates via fetchCartCount
      });
    });
  });

  // ===================== ACCORDIONS =====================
  var accordions = root.querySelectorAll("[data-accordion]");
  accordions.forEach(function (acc) {
    var header = acc.querySelector(".bb-accordion-header");
    if (!header) return;
    header.addEventListener("click", function () {
      acc.classList.toggle("bb-accordion-open");
    });
  });

  // ===================== STICKY BOTTOM CTA (scroll up) =====================
  (function initStickyCta() {
    var sticky = root.querySelector(".bb-sticky-cta");
    var stickyBtn = sticky ? sticky.querySelector(".bb-sticky-cta-btn") : null;
    var lastScrollY = window.scrollY;

    if (!sticky || !stickyBtn) return;

    window.addEventListener("scroll", function () {
      var currentY = window.scrollY;
      if (currentY > 400 && currentY < lastScrollY - 10) {
        sticky.classList.add("bb-sticky-cta-visible");
      } else if (currentY > lastScrollY + 10) {
        sticky.classList.remove("bb-sticky-cta-visible");
      }
      lastScrollY = currentY;
    });

    stickyBtn.addEventListener("click", function () {
      var bundles = document.getElementById("bb-bundles");
      smoothScrollTo(bundles);
    });
  })();

  // ===================== HAMBURGER MENU (Home / FAQ / Contact) =====================
  (function initMenu() {
    var hamburger = document.getElementById("bb-hamburger-button");
    if (!hamburger) return;

    var overlay = document.createElement("div");
    overlay.id = "bb-menu-overlay";
    overlay.className = "bb-menu-overlay";

    overlay.innerHTML =
      '<div class="bb-menu-panel">' +
      '<button type="button" class="bb-menu-close" aria-label="Close menu">×</button>' +
      '<nav class="bb-menu-nav">' +
      '<button type="button" class="bb-menu-link" data-menu-target="home">Home</button>' +
      '<button type="button" class="bb-menu-link" data-menu-target="faq">FAQ</button>' +
      '<button type="button" class="bb-menu-link" data-menu-target="contact">Contact</button>' +
      "</nav>" +
      "</div>";

    document.body.appendChild(overlay);

    var closeBtn = overlay.querySelector(".bb-menu-close");
    var menuLinks = overlay.querySelectorAll(".bb-menu-link");
    var faqSection = document.getElementById("bb-faq");
    var contactFooter = document.getElementById("bb-contact-footer");

    function openMenu() {
      overlay.classList.add("bb-menu-open");
    }
    function closeMenu() {
      overlay.classList.remove("bb-menu-open");
    }

    hamburger.addEventListener("click", function () {
      if (overlay.classList.contains("bb-menu-open")) {
        closeMenu();
      } else {
        openMenu();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener("click", closeMenu);
    }

    overlay.addEventListener("click", function (e) {
      if (e.target === overlay) closeMenu();
    });

    menuLinks.forEach(function (link) {
      link.addEventListener("click", function () {
        var target = link.getAttribute("data-menu-target");
        if (target === "home") {
          window.scrollTo({ top: 0, behavior: "smooth" });
        } else if (target === "faq" && faqSection) {
          smoothScrollTo(faqSection);
        } else if (target === "contact" && contactFooter) {
          smoothScrollTo(contactFooter);
        }
        closeMenu();
      });
    });
  })();
})();
